export default "__VITE_ASSET__nBQQAEUA__"